'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Component


// Drop Utils


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ElementDropTarget = require('../element/dnd/ElementDropTarget');

var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);

var _makeCanDropFn = require('../element/dnd/canDrop/makeCanDropFn');

var _makeCanDropFn2 = _interopRequireDefault(_makeCanDropFn);

var _preventDropOnSelfPredicate = require('../element/dnd/canDrop/preventDropOnSelfPredicate');

var _preventDropOnSelfPredicate2 = _interopRequireDefault(_preventDropOnSelfPredicate);

var _preventLinePredicate = require('../element/dnd/canDrop/preventLinePredicate');

var _preventLinePredicate2 = _interopRequireDefault(_preventLinePredicate);

var _elementConstants = require('../../common/elements/elementConstants');

require('./InboxClosed.scss');

var _inboxDropLocationFn = require('./inboxDropLocationFn');

var _inboxDropLocationFn2 = _interopRequireDefault(_inboxDropLocationFn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dropTargetConfig = {
    drop: _inboxDropLocationFn2.default,
    canDrop: (0, _makeCanDropFn2.default)([_preventDropOnSelfPredicate2.default, _preventLinePredicate2.default])
};

var InboxClosed = (_dec = (0, _ElementDropTarget2.default)(dropTargetConfig, _elementConstants.DROP_TARGET_TYPES.INBOX_CLOSED), _dec(_class = function (_React$Component) {
    _inherits(InboxClosed, _React$Component);

    function InboxClosed() {
        _classCallCheck(this, InboxClosed);

        return _possibleConstructorReturn(this, (InboxClosed.__proto__ || Object.getPrototypeOf(InboxClosed)).apply(this, arguments));
    }

    _createClass(InboxClosed, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                openInboxHandler = _props.openInboxHandler,
                inboxElementIds = _props.inboxElementIds,
                connectDropTarget = _props.connectDropTarget,
                isHovered = _props.isHovered;

            return connectDropTarget(_react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('InboxClosed', { hovered: isHovered, empty: inboxElementIds.length === 0 }) },
                _react2.default.createElement(
                    _Button2.default,
                    { onClickFn: openInboxHandler },
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'Unsorted '
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'count' },
                            inboxElementIds.length
                        )
                    )
                )
            ));
        }
    }]);

    return InboxClosed;
}(_react2.default.Component)) || _class);
exports.default = InboxClosed;


InboxClosed.propTypes = {
    currentBoardId: _propTypes2.default.string,
    openInboxHandler: _propTypes2.default.func,
    connectDropTarget: _propTypes2.default.func,
    inboxElementIds: _propTypes2.default.array,
    isHovered: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./src/client/inbox/InboxClosed.js
// module id = 2028
// module chunks = 0